export default {
    title_list: 'Promo Codes',
    title_page: 'Promo Code',
    title_create_page: 'Create promo code',
    title_edit_page: 'Change promo code',

    filter: {
        labels: {
            code: 'Code',
            membership_type: 'Membership type',
        }
    },

    table: {
        labels: {
            id: 'ID',
            code: 'Code',
            date_start: 'Start date',
            date_finish: 'Finish date',
            counter: 'Amount of use (old)',
            count: 'Amount of use by transactions',
            activated: 'Activated',
            sale: 'Discount(%)',
            amount: 'Discount($)',
            membership_type: 'Type',
        }
    },

    buttons: {
        generate: 'Generate code',
        generateQRCode: 'Generate QR code'
    },

    form: {
        code: 'Code',
        parent_id: 'User',
        date_start: 'Start date',
        date_finish: 'Finish date',
        sale: 'Discount (%)',
        activated: 'Activated',
        description: 'Description (Publicly viewable after enter promo code)',
        note: 'Note',
        max_count: 'Usage limit',
        counter: 'Amount of use',
        plan_id: 'Membership',
        amount: 'Discount ($)',
        membership_type: 'Membership type',
    },
}
